import React, { useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import { FiArrowUpRight, FiSend } from 'react-icons/fi';
import './Contact.css';

const Contact = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);

    try {
      const res = await fetch('/api/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="contact" ref={ref}>
      <div className="contact-container">
        {/* Big CTA Text */}
        <motion.div
          className="contact-cta"
          initial={{ opacity: 0, y: 60 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="label-text">Get in Touch</span>
          <h2 className="cta-title">
            Let's create
            <br />
            <span className="teal">something</span>
            <br />
            amazing together
          </h2>
          <a href="mailto:gafita.diana12@gmail.com" className="cta-link">
            <span>gafita.diana12@gmail.com</span>
            <FiArrowUpRight />
          </a>
        </motion.div>

        {/* Form & Info Grid */}
        <div className="contact-grid">
          {/* Info */}
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="info-item">
              <span className="info-label">Location</span>
              <span className="info-value">Romania, EU</span>
            </div>
            <div className="info-item">
              <span className="info-label">Availability</span>
              <div className="availability">
                <span className="pulse-dot" />
                <span>Open for projects</span>
              </div>
            </div>
            <div className="info-item">
              <span className="info-label">Response Time</span>
              <span className="info-value">Within 24 hours</span>
            </div>
          </motion.div>

          {/* Form */}
          <motion.form
            className="contact-form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Your name"
                required
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="your@email.com"
                required
              />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                placeholder="Tell me about your project..."
                rows="4"
                required
              />
            </div>
            <button type="submit" className="btn btn-teal" disabled={sending}>
              {sending ? 'Sending...' : 'Send Message'}
              <FiSend />
            </button>

            {status === 'success' && (
              <p className="form-status success">Message sent! I'll get back to you within 24 hours.</p>
            )}
            {status === 'error' && (
              <p className="form-status error">Something went wrong. Please try emailing me directly.</p>
            )}
          </motion.form>
        </div>
      </div>

      {/* Background Text */}
      <div className="contact-bg-text">CONTACT</div>
    </section>
  );
};

export default Contact;
